export default function arrayDifference<T>(left: T[], right: T[]): T[] {
  return left.filter((item) => !right.includes(item));
}
